import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { doOpenSearchPage } from 'actions/pages'
import { selectMailbox } from 'selectors/mailboxes_base'
import {
  heading,
  paragraph,
} from '@groovehq/internal-design-system/lib/styles/elements'
import { Check } from '@groovehq/internal-design-system/lib/assets/icons'
import alexImg from 'assets/alex-small@2x.png'

import TestMessageButton from '../Button'
import { styles } from '../styles'

const TestMessageContainer = ({ mailboxId }) => {
  const dispatch = useDispatch()
  const mailbox = useSelector(state => selectMailbox(state, mailboxId))
  const onMessageReceived = useCallback(
    ({ mailboxId: id, folderId }) =>
      dispatch(doOpenSearchPage(`inbox:${id} folder:${folderId}`)),
    [dispatch]
  )

  if (!mailbox) {
    return null
  }

  if (mailbox.testEmailStatus === 'sent') {
    return (
      <div className="grui p-12 pt-23 text-center" css={styles.container}>
        <Check className="grui mt-3 mb-16" css={styles.checkIcon} />
        <h3 css={heading.styles.h3}>Email sent!</h3>
        <p className="grui" css={[paragraph.styles.preflight, styles.subtitle]}>
          If all is set up correctly,
          <br />
          it should be in your {app.t('mailbox')} in less than a minute.
        </p>
      </div>
    )
  }

  return (
    <div className="grui p-12 pt-23 text-center" css={styles.container}>
      <img src={alexImg} css={styles.image} alt="alex" />
      <p className="grui mt-6 mb-12" css={styles.positionSubtitle}>
        <span>Alex,</span>
        CEO & Founder
      </p>

      <h3 css={heading.styles.h3}>
        Great job! You&#39;ve successfully set up your {app.t('mailbox')}!
      </h3>
      <p className="grui" css={[paragraph.styles.preflight, styles.subtitle]}>
        Now let me send you a test conversation to get a feel for how this feels
        in the wild :)
      </p>

      <TestMessageButton
        size="big"
        type="info"
        text={'💌 Send me a test email'}
        mailboxId={mailboxId}
        onMessageReceived={onMessageReceived}
      />
    </div>
  )
}

export default TestMessageContainer
